import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps, steps }) => {
  const progressPercentage = ((currentStep - 1) / (totalSteps - 1)) * 100;

  return (
    <div className="mb-8">
      {/* Progress Bar */}
      <div className="relative mb-6">
        <div className="w-full bg-muted h-2 rounded-full">
          <div 
            className="bg-primary h-2 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        
        {/* Step Indicators */}
        <div className="absolute top-0 left-0 w-full flex justify-between transform -translate-y-1">
          {steps?.map((step, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isCurrent = stepNumber === currentStep;
            
            return (
              <div
                key={step?.id}
                className="flex flex-col items-center"
                style={{ marginLeft: index === 0 ? '0' : '-12px', marginRight: index === steps?.length - 1 ? '0' : '-12px' }}
              >
                <div className={`w-6 h-6 rounded-full flex items-center justify-center border-2 transition-all ${
                  isCompleted 
                    ? 'bg-primary border-primary text-primary-foreground' 
                    : isCurrent
                    ? 'bg-background border-primary text-primary' :'bg-background border-muted-foreground text-muted-foreground'
                }`}>
                  {isCompleted ? (
                    <Icon name="Check" size={12} />
                  ) : (
                    <span className="text-xs font-medium">{stepNumber}</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* Step Labels */}
      <div className="grid grid-cols-5 gap-2">
        {steps?.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          
          return (
            <div key={step?.id} className="text-center">
              <div className={`text-xs font-medium ${
                isCompleted || isCurrent ? 'text-primary' : 'text-muted-foreground'
              }`}>
                {step?.title}
              </div>
              {isCurrent && (
                <div className="text-xs text-muted-foreground mt-1 hidden sm:block">
                  {step?.description}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* Mobile Current Step Info */}
      <div className="sm:hidden mt-4 p-3 bg-primary/10 rounded-lg">
        <div className="flex items-center space-x-2">
          <Icon name="Info" size={16} className="text-primary" />
          <div>
            <div className="text-sm font-medium text-primary">
              Step {currentStep} of {totalSteps}: {steps?.[currentStep - 1]?.title}
            </div>
            <div className="text-xs text-muted-foreground">
              {steps?.[currentStep - 1]?.description}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;